export default __webpack_public_path__ + "static/swftli-me-acfa0c56e7b2a6f0f6630b3410968b03.jpg";